
import $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class ImportFile extends Vue {
  /* PROPS */

  @Prop() private id: string;
  @Prop() private placeholder: string;
  @Prop({ default: "*" }) private accept: string;
  @Prop({ default: false }) private multiple: boolean;

  /* INITIALIZATION */

  private file: any = null;
  private files: any = [];

  constructor() {
    super();
  }

  private created() {
    $(document).ready(() => {
      const target = document.getElementById(`container${this.id}`);
      const $form = $(`#container${this.id}`);
      const onFileChanged = this.onFileChanged;
      /* tslint:disable */
      $form
        .on(
          "drag dragstart dragend dragover dragenter dragleave drop",
          function(e) {
            e.preventDefault();
            e.stopPropagation();
          }
        )
        .on("dragover dragenter", function(e) {
          $form.addClass("Dragging");
        })
        .on("dragleave dragend drop", function() {
          $form.removeClass("Dragging");
        })
        .on("drop", function(e) {
          onFileChanged((e as any).originalEvent.dataTransfer.files);
        });
      /* tslint:enable */
    });
  }

  /* METHODS */

  private onFileChanged(e: any) {
    let files;
    if (e instanceof Event) {
      const target = e.target as HTMLInputElement;
      files = target.files;
    } else {
      files = e;
    }
    if (this.multiple) {
      this.files = files;
      this.$emit("input", this.files);
    } else {
      this.file = Array.from(files || []).pop();
      this.$emit("input", this.file);
    }
    this.$emit("change");
  }

  private clear() {
    this.file = null;
    this.files = [];
  }
}
